/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_EmailInputs */

const en_invite_x15_email = /** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email me a sign-in link`)
};

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const ar_invite_x15_email = en_invite_x15_email;

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const he_invite_x15_email = en_invite_x15_email;

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const ur_invite_x15_email = en_invite_x15_email;

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const es_invite_x15_email = en_invite_x15_email;

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const fr_invite_x15_email = en_invite_x15_email;

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const de_invite_x15_email = en_invite_x15_email;

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const pt_invite_x15_email = en_invite_x15_email;

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const hi_invite_x15_email = en_invite_x15_email;

/** @type {(inputs: Invite_X15_EmailInputs) => LocalizedString} */
const bn_invite_x15_email = en_invite_x15_email;

/**
* | output |
* | --- |
* | "Email me a sign-in link" |
*
* @param {Invite_X15_EmailInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_email = /** @type {((inputs?: Invite_X15_EmailInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_EmailInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_email(inputs)
	if (locale === "he") return he_invite_x15_email(inputs)
	if (locale === "ur") return ur_invite_x15_email(inputs)
	if (locale === "es") return es_invite_x15_email(inputs)
	if (locale === "fr") return fr_invite_x15_email(inputs)
	if (locale === "de") return de_invite_x15_email(inputs)
	if (locale === "pt") return pt_invite_x15_email(inputs)
	if (locale === "hi") return hi_invite_x15_email(inputs)
	if (locale === "bn") return bn_invite_x15_email(inputs)
	return /** @type {LocalizedString} */ ("Email me a sign-in link")
});